// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6032) return "static/chunks/6032-4e6bcaf3d15c65ef.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2937 ? "eabe11fc" : chunkId) + "." + {"1167":"a210ed4baf32f694","2212":"37ebb86de3429296","2937":"9f346c793cd10593","3971":"a18f1368365de69b","4602":"3853afbad18303cf","4888":"3db5c3c1448cd57f"}[chunkId] + ".js";
};